import "./App.css";
import CliVideo from "./CliVideo";
import { useIsMobile } from "./hooks/usIsMobile";
import MobileWelcomePage from "./pages/MobileWelcomePage";

function App() {
  const isMobile = useIsMobile();

  return isMobile ? <MobileWelcomePage /> : <CliVideo />;
}

export default App;
